import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Loader } from "./core/Loader";
import logger from './utils/logger';
import * as Sentry from "@sentry/react";


logger.initalize();
const root = createRoot(document.getElementById("root"));
root.render(
  <Suspense fallback={<Loader />}>
    <Sentry.ErrorBoundary fallback={"An error has occurred"}>
      <App />
    </Sentry.ErrorBoundary>
  </Suspense>
);

serviceWorker.unregister();
